// extracted by mini-css-extract-plugin
export var blockMain = "BlockTokenStaking_blockMain__NECkE";
export var stakeCalculator = "BlockTokenStaking_stakeCalculator__DkGyn";
export var rotate = "BlockTokenStaking_rotate__c3EWr";
export var dotty = "BlockTokenStaking_dotty__TcJzr";